import styled from 'styled-components';

export const PaginationContainer = styled.nav`
	display: flex;
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	justify-content: center;
	margin-top: 4rem;
	ul {
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		li {
			margin-right: 0.5rem;
			border: 1px solid ${({ theme }) => theme.colors.borderColor};
			color: ${({ theme }) => theme.colors.primary};
			cursor: pointer;
			font-family: ${({ theme }) => theme.fonts.ArimoMedium};
			display: list-item;
			a {
				display: block;
				padding: 1rem 2rem;
			}

			&.active {
				background-color: ${({ theme }) => theme.colors.secondary};
				color: #fff;
			}
		}
	}
`;
